<section class="bg-white rounded-lg shadow-md p-4 mt-4">
  <div class="flex justify-between items-center">
    <h3 class="text-lg font-medium">{{ title }}</h3>
    <div *ngIf="loading" class="text-sm text-gray-500">Loading attachments…</div>
    <div *ngIf="!loading && !hasAttachments()" class="text-sm text-gray-500">No attachments</div>
  </div>

  <div class="mt-3 space-y-2" *ngIf="!loading && hasAttachments()">
    <div
      *ngFor="let f of attachments"
      class="flex justify-between items-center gap-3 p-2 rounded-md border border-gray-100"
    >
      <div class="flex items-center gap-3">
        <div
          class="w-9 h-9 rounded-md bg-gray-50 flex items-center justify-center text-gray-600 text-sm"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M7 7h10M7 11h10M7 15h6"
            />
          </svg>
        </div>
        <div>
          <div class="font-medium text-sm">{{ f.title || f.name }}</div>
          <div class="text-xs text-gray-500">{{ f.description || (f.name + ' • ' + (f.type | uppercase)) }}</div>
        </div>
      </div>

      <div class="flex items-center gap-2">
        <button
          *ngIf="showPreview"
          aria-label="Preview file"
          (click)="previewAttachment(f)"
          class="inline-flex items-center justify-center w-9 h-9 rounded-lg border border-neutral-300 bg-white text-neutral-700 hover:bg-neutral-100 hover:border-neutral-400 active:scale-95 transition focus:outline-none focus:ring-2 focus:ring-primary-500"
        >
          <mat-icon class="text-lg leading-none">visibility</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>

<app-file-preview #attachmentPreview></app-file-preview>

